import { render, staticRenderFns } from "./Custommap.vue?vue&type=template&id=2d04f105"
import script from "./Custommap.vue?vue&type=script&setup=true&lang=js"
export * from "./Custommap.vue?vue&type=script&setup=true&lang=js"
import style0 from "./Custommap.vue?vue&type=style&index=0&id=2d04f105&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports